import { Navigate, Outlet, RouteObject } from 'react-router-dom';
import type { RouterProps } from 'contracts/Router';
import { HoraCertaImportPage } from 'pages/Imports/HoraCerta';
import { QuarantinePage } from 'pages/Imports/Quarantine';
import type React from 'react';

const orderImportsRoutes = ({
  location,
  userBelongsToAnyOf,
}: RouterProps): RouteObject => {
  const adminElement = (element: React.ReactElement) =>
    userBelongsToAnyOf('admin', 'warehouseMember') ? (
      element
    ) : (
      <Navigate to="/" state={{ from: location }} />
    );

  return {
    path: 'importacao',
    element: <Outlet />,
    children: [
      {
        path: 'hora-certa',
        element: adminElement(<HoraCertaImportPage />),
      },
      {
        path: 'quarentena',
        element: adminElement(<QuarantinePage />),
      },
    ],
  };
};

export default orderImportsRoutes;
